import React from 'react'
import { Pie } from 'react-chartjs-2'
import styled from 'styled-components';
import i18n from '../i18n';

const placeData = (data) => {
  const { real_income_month, monthly_spends_on_therapy } = data;
  return ({
    labels: [i18n.t('currentSpends.monthlySpends'), i18n.t('currentSpends.realIncome')],
    datasets: [
      {
        data: [monthly_spends_on_therapy || 0, real_income_month || 0],
        backgroundColor: ['#E94335', '#47D789'],
      },
    ],
  })
};

const CurrentSpends = (props) => {
  const { data } = props;

  return (
    <Container>
      <Header>
        <h5>{i18n.t('currentSpends.title')}</h5>
      </Header>
      <Pie data={placeData(data)} />
    </Container>
  )
};

export default CurrentSpends;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const Header = styled.div`
  text-align: center;
`;
